import TextArea from '~/components/TextArea'

type StepReviewWriteProps = {
    form?: any
}

const StepReviewWrite = ({ form }: StepReviewWriteProps) => {

    return (
        <div className='flex flex-col justify-center items-center gap-10'>
            <p className='text-2xl font-medium text-center'>Tell us more!</p>
            <div className='w-full'>
                <TextArea
                    required
                    placeholder="Enter your review"
                    {...form.getFieldProps("content")}
                />
            </div>
        </div>
    )
}

export default StepReviewWrite